import { Box, Stack, Text } from "@mantine/core";
import CallbackItem from "./CallbackItem";
import CallbackListQuery from "./CallbackListQuery";
import classes from "../..//Home.module.css";
import { useTranslation } from "react-i18next";

export default function CallbackList() {
  const { totalCount, todaysCallbacks, missedCallbacks } = CallbackListQuery();
  const { t } = useTranslation("features");

  if (totalCount == 0) {
    return (
      <Box className={classes.listContainer}>
        <Box className={classes.noListItem}>
          <Text w={"100%"} className={classes.listNoItemsText}>
            {t(`home.noCallbacks`)}
          </Text>
        </Box>
      </Box>
    );
  }

  return (
    <Box>
      <Stack className={classes.listContainer} gap={8}>
        {todaysCallbacks.map((callback, index) => {
          return <CallbackItem key={index} callback={callback} />;
        })}
      </Stack>
      <Stack className={classes.listContainer} gap={8}>
        <Text className={classes.listSectionLabel}>
          {t(`home.missedCallbacks`)}
        </Text>
        {missedCallbacks.map((callback, index) => {
          return <CallbackItem key={index} callback={callback} />;
        })}
      </Stack>
    </Box>
  );
}
